import { render, staticRenderFns } from "./DisambiguationModal.vue?vue&type=template&id=da7c0c88&scoped=true&"
import script from "./DisambiguationModal.js?vue&type=script&lang=js&"
export * from "./DisambiguationModal.js?vue&type=script&lang=js&"
import style0 from "./DisambiguationModal.scoped.scss?vue&type=style&index=0&id=da7c0c88&lang=scss&scoped=true&"
import style1 from "./DisambiguationModal.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da7c0c88",
  null
  
)

export default component.exports